import CommonError from "../../component/other-pages/error/common/CommonError"
import {   error404 } from "../../component/other-pages/error/error-svg"

 
function ErrorPage() {
  return (
    <div> <CommonError src={error404} /></div>
  )
}

export default ErrorPage